export var OrdersStates;
(function(OrdersStates) {
    OrdersStates["Both"] = "both";
    OrdersStates["None"] = "none";
    OrdersStates["OrderOutstanding"] = "orderOutstanding";
    OrdersStates["OrderFulfilled"] = "orderFulfilled";
})(OrdersStates || (OrdersStates = {}));
